import { render, staticRenderFns } from "./FooterButton.vue?vue&type=template&id=4f060dd6&scoped=true&"
import script from "./FooterButton.vue?vue&type=script&lang=js&"
export * from "./FooterButton.vue?vue&type=script&lang=js&"
import style0 from "./FooterButton.vue?vue&type=style&index=0&id=4f060dd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f060dd6",
  null
  
)

export default component.exports